import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { Store } from '@ngrx/store';
import { SubSink } from 'subsink';

import { AuthenticationSelectors } from '@authentication/store/authentication.slice';
import {
  MerchantActions,
  MerchantSelectors,
} from '@merchant/store/merchant.slice';

@Component({
  selector: 'app-operating-license',
  templateUrl: './operating-license.component.html',
  styleUrls: ['./operating-license.component.scss'],
})
export class OperatingLicenseComponent implements OnInit, OnDestroy {
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @Input() siteId?: string;
  @Input() inputMerchantId?: string;
  @Input() readOnly?: boolean;

  subs = new SubSink();

  merchantId?: string;

  fileInStore?: File;

  isUploading$ = this.store.select(
    MerchantSelectors.selectIsOperatingLicenseUploading
  );
  uploadProgress$ = this.store.select(
    MerchantSelectors.selectOperatingLicenseUploadProgress
  );
  operatingLicense$ = this.store.select(
    MerchantSelectors.selectOperatingLicense
  );

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    if (this.inputMerchantId && this.siteId) {
      this.loadOperatingLicense(this.inputMerchantId, this.siteId);
    } else if (!this.inputMerchantId) {
      this.subs.add(
        this.store
          .select(AuthenticationSelectors.selectUserInfo)
          .subscribe((userInfo) => {
            if (userInfo.attributes?.['custom:merchantId']) {
              this.merchantId = userInfo.attributes?.['custom:merchantId'];
              this.loadOperatingLicense(this.merchantId, this.siteId);
            } else {
              this.subs.add(
                this.store
                  .select(AuthenticationSelectors.selectMerchantId)
                  .subscribe((merchantId) => {
                    this.merchantId = merchantId;
                    this.loadOperatingLicense(this.merchantId, this.siteId);
                  })
              );
            }
          })
      );
    }

    this.subs.add(
      this.store
        .select(MerchantSelectors.selectOperatingLicenseInStore)
        .subscribe((op) => {
          this.fileInStore = op;
        })
    );
  }

  loadOperatingLicense(merchantId?: string, siteId?: string) {
    if (merchantId && siteId) {
      this.store.dispatch(
        MerchantActions.loadOperatingLicense.trigger({
          merchantId: merchantId,
          siteId: siteId,
        })
      );
    }
  }

  onUploadFile(event: Event): void {
    const files: FileList | null = (event.target as HTMLInputElement).files;

    if (files && this.merchantId && this.siteId) {
      this.store.dispatch(
        MerchantActions.uploadOperatingLicense.trigger({
          file: files[0],
          merchantId: this.merchantId ?? '',
          siteId: this.siteId ?? '',
        })
      );

      if (this.fileInput) {
        (this.fileInput.nativeElement as HTMLInputElement).value = '';
      }
    } else if (files && this.merchantId && !this.siteId) {
      this.store.dispatch(
        MerchantActions.uploadOperatingLicenseToStore.trigger({
          file: files[0],
          merchantId: this.merchantId ?? '',
        })
      );

      if (this.fileInput) {
        (this.fileInput.nativeElement as HTMLInputElement).value = '';
      }
    }
  }

  openLocalFile() {
    if (this.fileInStore) {
      const reader = new FileReader();

      reader.onloadend = (e: any) => {
        let pdfWindow = window.open('');
        pdfWindow?.document.write(
          "<iframe width='100%' height='100%' src='" +
            encodeURI(e.target.result) +
            "'></iframe>"
        );
      };

      reader.readAsDataURL(this.fileInStore);
    }
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
